import React, {useState,useEffect, useCallback} from "react";
import { useLocation } from "react-router-dom";
import { readProductsFromDB } from "../../../services/firebase";
import  '../../../style.css'
import { StyleSheet, css } from "aphrodite";
import ProductAux from "./product_aux";
import { OrbitProgress } from "react-loading-indicators"



export default function ProductPage({mainImage, title, productTpe, description, 
    secondImage, firstMiniTitle, fisrtMiniDescription, thirdImage, secondMiniDescription,
    secondMiniTitle, specs, otherImages, getProductInfo=true
}){

    const [products, setProducts] = useState(null)
    const [productData, setProductData] = useState()
    const location = useLocation();

    useEffect(()=>{
        if(getProductInfo)
            readProductsFromDB(setProducts)
        filter()
    },[products])
    useEffect(()=>{
        filter()
    
    },[location])
    const filter = () =>{
        if(getProductInfo && products !== null){
            let data = Object.values(products).filter((product)=>product.url === location.pathname)
            console.log(data)
            console.log(products)
            setProductData(data[0])
        }
    }
    const containerStyle ={
        display:"flex",
        justifyContent: ' center',
        alignItems: 'center',
        height:"50rem"
    }
    return(
        <>
            {
                getProductInfo ? 
                <>{
                    productData?
              
                <ProductAux
                    mainImage={productData.mainImage}
                    title={productData.title}
                    productTpe={productData.productTpe}
                    description={productData.description}
                    secondImage={productData.secondImage}
                    firstMiniTitle={productData.firstMiniTitle}
                    fisrtMiniDescription={productData.fisrtMiniDescription}
                    thirdImage={productData.thirdImage}
                    secondMiniDescription={productData.secondMiniDescription}
                    secondMiniTitle={productData.secondMiniTitle}
                    specs={productData.specs}
                    otherImages={productData.otherImages}
                />:                   
                <div style={containerStyle}>
                    <OrbitProgress color="#011a39" size="large" text="" textColor="" />
                </div>
            }</>  :

                <>
                <ProductAux
                    mainImage={mainImage}
                    title={title}
                    productTpe={productTpe}
                    description={description}
                    secondImage={secondImage}
                    firstMiniTitle={firstMiniTitle}
                    fisrtMiniDescription={fisrtMiniDescription}
                    thirdImage={thirdImage}
                    secondMiniDescription={secondMiniDescription}
                    secondMiniTitle={secondMiniTitle}
                    specs={specs}
                    otherImages={otherImages}
                />
                </>
            }
        </>
    )
}